type CacheRule = {
  path: RegExp | string;
  ttl?: number;
};

const cacheRules: CacheRule[] = [
  { path: "/api/v1/enum/schedule_type" },
  { path: "/api/v1/enum/schedule_frequency" },
];

export default cacheRules;
